import { Injectable } from '@angular/core';
import { HostService } from './host.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private getHost: HostService, private http: HttpClient) { }

  fetchNotificationOfAdmin() {

    return this.http.get(this.getHost.gethttps() + "fetchNotificationOfAdmin");

  }

  fectNotificationOfAdminForUserAdd() {

    return this.http.get(this.getHost.gethttps() + "fectNotificationOfAdminForUserAdd");

  }
  
}
